module.exports = __webpack_public_path__ + "static/media/speaker.a6a34ed2.png";